import React from 'react'
import Page from '../Page/Page'
import PageContent from '../Page/PageContent'
import TitleToolbar from '../Page/TitleToolbar'
import FilterCheckboxContainer from './FilterCheckboxContainer'
import LabelsCheckboxContainer from './LabelsCheckboxContainer'
import List from '@material-ui/core/List'
import ListSubheader from '@material-ui/core/ListSubheader'
import ListItem from '@material-ui/core/ListItem'
import BasemapRadioContainer from './BasemapRadioContainer'
import SridSelectorContainer from './SridSelectorContainer'

import RiksavvägningenImage from './riksavvägningen.png'
import SwerefImage from './sweref.png'
import Rix95Image from './rix95.png'

import FörstördImage from './förstörd.png'
import EtiketterImage from './etiketter.png'

import TopowebbImage  from './topowebb.png'
import TopowebbNedtonadImage from './topowebbNedtonad.png'
import OrtofotoImage from './ortofoto.png'

export default () => (
    <Page>
        <TitleToolbar title="Visa" />
        <PageContent>
        <List>
            <ListSubheader disableSticky>Nät</ListSubheader>
        	<FilterCheckboxContainer
        		value = "riksavvägningen"
        		label = "Höjd"
        		text = "RH 2000"
                image = {RiksavvägningenImage}
                labelId ="riksavvagningen"
        	/>
			<FilterCheckboxContainer
				value = "sweref"
				label = "Plan, klass 1"
				text = "SWEREF 99"
                image = {SwerefImage}
                labelId = "sweref"
			/>
			<FilterCheckboxContainer
				value ="rix95"
				label ="Plan, klass 2"
				text = "SWEREF 99"
                image = {Rix95Image}
                labelId = "riks95"
			/>
            <ListSubheader disableSticky>Alternativ</ListSubheader>
        	<FilterCheckboxContainer
        		value = "förstörda"
        		label = "Visa förstörda punkter"
                image = {FörstördImage}
                labelId = "forstorda"
        	/>
            <LabelsCheckboxContainer
                label = "Visa etiketter"
                image = {EtiketterImage}
                labelId = "etiketter"
            />
            <ListSubheader disableSticky>Bakgrundskarta</ListSubheader>
            <BasemapRadioContainer
                value = "TOPOWEBB"
                label = "Topografisk"
                image = {TopowebbImage}
                labelId = "topografisk"
            />
            <BasemapRadioContainer
                value = "TOPOWEBB_NEDTONAD"
                label = "Topografisk (nedtonad)"
                image = {TopowebbNedtonadImage}
                labelId = "topografisknedtonad"
            />
            <BasemapRadioContainer
                value = "ORTOFOTO"
                label = "Ortofoto"
                image = {OrtofotoImage}
                labelId = "ortofoto"
            />
            <ListSubheader disableSticky>Koordinatsystem</ListSubheader>
            <ListItem>
                <SridSelectorContainer />
            </ListItem>
        </List>
        </PageContent>
	</Page>
)


// WEBPACK FOOTER //
// ./src/components/Filter/FilterPage.js